import { render, staticRenderFns } from "./CreditScoringManajemenBisnis.vue?vue&type=template&id=2250f633&scoped=true&"
import script from "./CreditScoringManajemenBisnis.vue?vue&type=script&lang=js&"
export * from "./CreditScoringManajemenBisnis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250f633",
  null
  
)

export default component.exports